__webpack_require__.p = "/manufac-javascript-react-winedata-stats-refactored-code/";